export default __webpack_public_path__ + "peccy-permissions-gate.29a532e3.png";